import React from 'react';

const CategoryLoader: React.FC = () => {
  return (
    <article className="flex-shrink-0 w-[48%] sm:w-[38%] md:w-[29%] lg:w-[20%] relative item-card overflow-hidden rounded-15 sell-cat-item group snap-start">
      <figure
        className="w-full rounded-15 overflow-hidden bg-grey-loader animate-pulse"
        style={{ paddingTop: "100%" }}
      ></figure>
    </article>
  );
};

export default CategoryLoader;